import React from 'react';
import { useNavigate } from "react-router-dom";

// ===== DATOS DE SEGUROS =====
const seguros = [
  {
    id: "auto",
    title: "Seguro de Auto",
    description: "Protege tu vehículo contra accidentes y robos",
    route: "/SeguroDeAuto",
    image: "https://images.unsplash.com/photo-1449824913935-59a10b8d2000?w=300&h=200&fit=crop"
  },
  {
    id: "gastos-medicos",
    title: "Seguro de Gastos Médicos Mayores",
    description: "Cobertura médica completa para tu tranquilidad",
    route: "/SeguroDeGastosMedicosMayores",
    image: "https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=300&h=200&fit=crop"
  },
  {
    id: "hogar",
    title: "Seguro del Hogar",
    description: "Protege tu casa y tus bienes más preciados",
    route: "/SeguroDelHogar",
    image: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=300&h=200&fit=crop"
  },
  {
    id: "viajes",
    title: "Seguro de Viajes",
    description: "Viaja tranquilo con la mejor protección",
    route: "/SeguroDeViajes",
    image: "https://images.unsplash.com/photo-1488646953014-85cb44e25828?w=300&h=200&fit=crop"
  },
  {
    id: "vida",
    title: "Seguro de Vida",
    description: "Asegura el futuro de quienes más amas",
    route: "/SeguroDeVida",
    image: "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=300&h=200&fit=crop"
  }
];

// ===== ESTILOS =====
const containerStyle = {
  display: "flex",
  justifyContent: "center",
  marginTop: "2%",
  flexWrap: "wrap",
  gap: "1.4%",
  rowGap: "10px"
};

const cardStyle = {
  width: "16%",
  padding: "1%",
  paddingBottom: "3.72%",
  borderRadius: "3%",
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
  textAlign: "center",
  backgroundColor: "#fff",
  cursor: "pointer",
  transition: "transform 0.3s ease, box-shadow 0.3s ease"
};

const imageStyle = {
  width: "100%",
  borderRadius: "5px",
  height: "120px",
  objectFit: "cover"
};

const titleStyle = {
  fontSize: "1.1rem",
  fontWeight: "600",
  color: "#0c1f4d",
  margin: "10px 0 5px 0"
};

const descriptionStyle = {
  fontSize: "0.9rem",
  color: "#666",
  lineHeight: "1.4"
};

// ===== COMPONENTE PRINCIPAL =====
export default function ServiciosHub() {
  const navigate = useNavigate();

  const handleCardClick = (route) => {
    navigate(route);
  };

  const handleCardHover = (e, isEntering) => {
    if (isEntering) {
      e.currentTarget.style.transform = 'translateY(-5px)';
      e.currentTarget.style.boxShadow = '0 8px 16px rgba(0, 0, 0, 0.3)';
    } else {
      e.currentTarget.style.transform = 'translateY(0)';
      e.currentTarget.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.2)';
    }
  };

  return (
    <div style={containerStyle}>
      {seguros.map((seguro) => (
        <div
          key={seguro.id}
          style={cardStyle}
          onClick={() => handleCardClick(seguro.route)}
          onMouseEnter={(e) => handleCardHover(e, true)}
          onMouseLeave={(e) => handleCardHover(e, false)}
          title={`Ir a ${seguro.title}`}
        >
          <img 
            src={seguro.image} 
            alt={seguro.title} 
            style={imageStyle}
            loading="lazy"
          />
          <h3 style={titleStyle}>
            {seguro.title}
          </h3>
          <p style={descriptionStyle}>
            {seguro.description}
          </p>
        </div>
      ))}
    </div>
  );
}